<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 공포기간 -->
          <c-datepicker
            :range="true"
            defaultStart="-2y"
            defaultEnd="2M"
            label="LBL0010103"
            name="promulgationPeriod"
            v-model="searchParam.promulgationPeriod"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-2y"
            defaultEnd="2M"
            label="시행기간"
            name="enforcementPeriod"
            v-model="searchParam.enforcementPeriod"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="curHistoryItems"
            itemText="codeName"
            itemValue="code"
            type="search"
            label="현행연혁코드"
            name="curHistoryCode"
            v-model="searchParam.curHistoryCode"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="lawTypeItmes"
            itemText="codeName"
            itemValue="code"
            type="search"
            label="법령 구분"
            name="lawClassName"
            v-model="searchParam.lawClassName"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-field type="user" label="담당자" name="userId" v-model="searchParam.userId" />
        </div>
      </template>
    </c-search-box>
    <!--법령 목록-->
    <c-table
      title="LBL0010096"
      tableId="safetyControlDangerous"
      :columns="grid.columns"
      :data="grid.data"
      :customTrClass="setTrClass"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'reasonText' && props.row[col.name]">
          <div
            class="cursor-pointer text-grey-9"
            style="
              max-width: 250px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              line-clamp: 2;
              overflow: hidden;
            "
          >
            <q-tooltip>재개정사유 상세</q-tooltip>
            <q-btn flat round dense icon="article" color="blue-grey-5" size="sm">
              <q-popup-proxy transition-show="scale" transition-hide="scale">
                <q-card style="width: 500px; max-width: 90vw; max-height: 50vh" class="scroll">
                  <q-card-section class="bg-blue-grey-1 sticky-top" style="z-index: 1">
                    <div class="text-subtitle2 text-weight-bold text-blue-9">
                      <q-icon name="info" size="xs" class="q-mr-xs" /> 재개정사유 상세
                    </div>
                  </q-card-section>
                  <q-separator />
                  <q-card-section>
                    <div
                      class="text-body2"
                      style="white-space: pre-wrap; word-break: keep-all;"
                    >
                      {{ props.row.reasonText }}
                    </div>
                  </q-card-section>
                </q-card>
              </q-popup-proxy>
            </q-btn>
            {{ props.row.reasonText }}

            <q-popup-proxy transition-show="scale" transition-hide="scale">
              <q-card style="width: 500px; max-width: 90vw; max-height: 50vh" class="scroll">
                <q-card-section class="bg-blue-grey-1 sticky-top" style="z-index: 1">
                  <div class="text-subtitle2 text-weight-bold text-blue-9">
                    <q-icon name="info" size="xs" class="q-mr-xs" /> 재개정사유 상세
                  </div>
                </q-card-section>

                <q-separator />

                <q-card-section>
                  <div
                    class="text-body2"
                    style="white-space: pre-wrap; word-break: keep-all; line-height: 1.6"
                  >
                    {{ props.row.reasonText }}
                  </div>
                </q-card-section>
              </q-card>
            </q-popup-proxy>
          </div>
        </template>
        <template v-if="col.name === 'oldAndNew' || (col.name === 'custom' && props.row.lawLink)">
          <q-btn
            class="tableinnerBtn"
            flat
            icon="launch"
            align="center"
            color="blue-6"
            label=""
            @click.stop="linkClick(props, col)"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safety-control-dangerous',
  data() {
    return {
      searchParam: {
        promulgationPeriod: [],
        enforcementPeriod: [],
        curHistoryCode: '시행예정',
        lawClassName: null,
        userId: null
      },
      grid: {
        columns: [
          {
            name: 'lawSerialNum',
            field: 'lawSerialNum',
            //법령일련번호
            label: 'LBL0010097',
            align: 'center',
            sortable: false,
            style: 'width:60px',
          },
          {
            name: 'curHistroyCode',
            field: 'curHistroyCode',
            //현행연혁코드
            label: 'LBL0010098',
            align: 'center',
            sortable: false,
            style: 'width:60px',
          },
          {
            name: 'lawNameKor',
            field: 'lawNameKor',
            //법령명한글
            label: 'LBL0010079',
            align: 'left',
            sortable: true,
            style: 'width:120px',
          },
          {
            name: 'lawNameAbb',
            field: 'lawNameAbb',
            //법령약칭명
            label: 'LBL0010080',
            align: 'left',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'promulgationDate',
            field: 'promulgationDate',
            label: '공포일',
            align: 'center',
            sortable: true,
            style: 'width:60px',
          },
          {
            name: 'enforcementDate',
            field: 'enforcementDate',
            label: '시행일',
            align: 'center',
            sortable: true,
            style: 'width:60px',
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            label: '등록일',
            align: 'center',
            sortable: true,
            style: 'width:60px'
          },
          {
            name: 'chgDtStr',
            field: 'chgDtStr',
            label: '수정일',
            align: 'center',
            sortable: true,
            style: 'width:60px'
          },
          {
            name: 'revisionTypeName',
            field: 'revisionTypeName',
            //제개정구분명
            label: 'LBL0010099',
            align: 'center',
            sortable: false,
            style: 'width:60px',
          },
          {
            name: 'competentMinistriesName',
            field: 'competentMinistriesName',
            //소관부처명
            label: 'LBL0010100',
            align: 'left',
            sortable: false,
            style: 'width:120px',
          },
          {
            name: 'lawClassNameReal',
            field: 'lawClassNameReal',
            label: '법령구분',
            align: 'center',
            sortable: false,
            style: 'width:60px',
          },
          {
            name: 'managerNames',
            field: 'managerNames',
            label: '법령담당자',
            align: 'left',
            sortable: false,
            headerStyle: 'width:80px'
          },
          {
            name: 'reasonText',
            field: 'reasonText',
            label: '재개정사유',
            align: 'left',
            sortable: false,
            style: 'width:60px',
            type: 'custom'
          },
          {
            name: 'oldAndNew',
            field: 'oldAndNew',
            label: '신구법비교',
            align: 'center',
            sortable: false,
            style: 'width:50px',
            type: 'custom'
          },
          {
            name: 'custom',
            field: 'custom',
            //법령상세링크
            label: 'LBL0010086',
            align: 'center',
            sortable: false,
            style: 'width:50px',
            type: 'custom'
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      curHistoryItems: [
        { code: '현행', codeName: '현행' },
        { code: '시행예정', codeName: '시행예정' },
        { code: '연혁', codeName: '연혁' }
      ],
      lawTypeItmes: [
        { code: '법률', codeName: '법률' },
        { code: '시행령', codeName: '시행령' },
        { code: '시행규칙', codeName: '시행규칙' },
        { code: '행정규칙', codeName: '행정규칙' }
      ],
      keyId: ""
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.law.list.url
      // code setting
      // list setting
      this.$http.url = this.$format(selectConfig.sys.env.get.url, 'LAW_SEARCH_KEYID');
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.keyId = _result.data.attrVal01;
      },);
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(_props, _col) {
      if (_col.name === 'custom') {
        window.open('https://www.law.go.kr' + _props.row.lawLink, '법규', 'width=1200, height=800');
      }
      if (_col.name === 'oldAndNew') {
        if (_props.row.lawClassName === '행정규칙') {
          window.open(
            `https://www.law.go.kr/DRF/lawService.do?OC=${_props.row.oc}&target=admrulOldAndNew&ID=${_props.row.lawSerialNum}&type=HTML`,
            '신구법 비교',
            'width=1200,height=800'
          )
        } else {
          window.open(
            `https://www.law.go.kr/DRF/lawService.do?OC=${_props.row.oc}&target=oldAndNew&MST=${_props.row.lawSerialNum}&type=HTML`,
            '신구법 비교',
            'width=1200,height=800'
          )
        }
      }
    },
    setTrClass(_props) {
      return (_props.row.regDtStr === this.$comm.getToday() || _props.row.chgDtStr === this.$comm.getToday()) &&
        _props.row.managers.includes(this.$store.getters.user.userId)
        ? 'bg-orange-1'
        : ''
    }
  }
};
</script>
